// extracted by mini-css-extract-plugin
export default {"card":"IntegrationCard_card__+an4e","header":"IntegrationCard_header__+2F1J"};